import { useTranslation } from "react-i18next";

function InputLingoLanguages({ name, data, inputChange }) {
  const { t } = useTranslation();

  const lingoTools = [
    { id: 0, name: t("SELECT") },
    { id: 1, name: "Skype" },
    { id: 2, name: "Zoom" },
    { id: 3, name: "Webex" },
    { id: 4, name: "Google Meet" },
    { id: 5, name: "Tokbox" },
    { id: 6, name: "Skype for Business" },
    { id: 7, name: "Blue Jeans" },
    { id: 8, name: "Microsoft Teams" },
    { id: 9, name: "Other" },
  ];

  return (
    <div className="input-lingoClassTool">
      <label htmlFor={name}>{t("CLASS_TOOL")}</label>
      <div className="select-wrapper">
        <select name={name} value={data.value ? data.value : ""} onChange={inputChange}>
          {lingoTools?.map((option) => (
            <option key={option.id} value={option.name}>
              {option.name}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
}

export default InputLingoLanguages;
